import { ElementRef } from '@angular/core';
import { FontTypeEnum } from 'src/app/model/enums/FontTypeEnum';
import { OnInit } from '@angular/core';
import { Directive } from '@angular/core';
import { SessionService } from '../session-service.service';

@Directive({
  selector: '[appConfigSettingsBorder]'
})
export class ConfigSettingsBorderDirective implements OnInit {
  FontTypeEnum = FontTypeEnum;

  constructor(private elementRef: ElementRef<any>, private sessionService: SessionService) { }

  ngOnInit(): void {
    this.elementRef.nativeElement.style.borderColor = this.sessionService.getConfigSettingsDto().inputBorderColor;
  }
}
